module.exports = __webpack_public_path__ + "img/PL08791.67b8c4b5.png";